import { VALIDATION_SETUP_MARKER } from './constants.mjs';

export default function markAsSetup(node) {
  node.dataset[VALIDATION_SETUP_MARKER] = '';
}
